import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './utils/analytics';
import { capturarAtribucion } from './utils/atribucion';

// Primero la atribución: lee el gclid de la URL antes de que el router pueda
// tocarla, para no perder de qué anuncio viene la visita.
capturarAtribucion();
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
